'use strict';

module.exports = {
  'New York,NY,United States': 'New York City',
  'Washington,DC,United States': 'Washington D.C.',
  'Boston,MA,United States': 'Boston',
  'Los Angeles,CA,United States': 'Los Angeles',
  'San Francisco,CA,United States': 'San Francisco',
  'Chicago,IL,United States': 'Chicago'
};